import { Box } from "@mui/material";
import { formatMonth } from "common/functions/utilities";
import { UseDistrictProperty } from "common/interfaces/UseDistrictGeoJSON";
import { EstateType } from "graphql/API";
import React, { useMemo } from "react";
import { ContentBasic } from "./ContentBasic";
import { ContentTail } from "./ContentTail";
import { ContentWrapper } from "./ContentWrapper";
import styles from "./DetailPage.subComponents.module.scss";

export const CondominiumContent = React.memo(
  (props: {
    estate?: EstateType;
    eSchools?: string[];
    jSchools?: string[];
    useDistricts?: Partial<UseDistrictProperty>[];
    roadInfos: string[];
  }) => {
    const structure = useMemo(() => {
      const structureStr = [
        props.estate?.structure,
        props.estate?.structureFree
      ]
        .filter((x) => x)
        .join(" ");

      return structureStr === "" ? null : structureStr;
    }, [props.estate?.structure, props.estate?.structureFree]);

    const currentStatus = useMemo(() => {
      const currentStatusStr = [
        props.estate?.currentStatus,
        props.estate?.currentStatusFree
      ]
        .filter((x) => x)
        .join(", ");

      return currentStatusStr === "" ? null : currentStatusStr;
    }, [props.estate?.currentStatus, props.estate?.currentStatusFree]);

    const clearingType = useMemo(() => {
      const clearingTypeStr = [
        props.estate?.clearingType,
        props.estate?.clearingType === "期日指定" && props.estate?.cleaningMonth
          ? `(${formatMonth(props.estate?.cleaningMonth)})`
          : null
      ]
        .filter((x) => x)
        .join(" ");

      return clearingTypeStr === "" ? null : clearingTypeStr;
    }, [props.estate?.cleaningMonth, props.estate?.clearingType]);

    return (
      <ContentWrapper>
        <Box className={styles.name}>
          <strong>{props.estate?.name ?? "−"}</strong>
        </Box>

        <Box className={styles.price}>
          <Box>価格</Box>
          <Box>{props.estate?.estatePrice ?? "−"} 万円</Box>
        </Box>

        <ContentBasic estate={props.estate} />

        <Box className={`${styles.structure} ${styles.condominium}`}>
          <Box>専有面積</Box>
          <Box>{props.estate?.squareArea ?? "−"} ㎡</Box>

          <Box>間取り</Box>
          <Box>{props.estate?.layout ?? "−"}</Box>
        </Box>

        <Box className={`${styles.structure} ${styles.condominium}`}>
          <Box>管理費</Box>
          <Box>
            {props.estate?.managementFee
              ? `${props.estate?.managementFee} 円`
              : "−"}
          </Box>

          <Box>修繕費</Box>
          <Box>
            {props.estate?.repairCost ? `${props.estate?.repairCost} 円` : "−"}
          </Box>
        </Box>

        <Box className={`${styles.structure} ${styles.condominium}`}>
          <Box>駐車場</Box>
          <Box>{props.estate?.parking ?? "−"}</Box>

          <Box>所在階</Box>
          <Box>{props.estate?.floor ?? "−"}</Box>
        </Box>

        <Box className={`${styles.conditions} ${styles.condominium}`}>
          <Box>バルコニー</Box>
          <Box>
            {props.estate?.balconyArea
              ? `${props.estate?.balconyArea} ㎡`
              : "−"}
          </Box>

          <Box>構造</Box>
          <Box>{structure ?? "−"}</Box>

          <Box>完成</Box>
          <Box>
            {props.estate?.completionMonth
              ? formatMonth(props.estate?.completionMonth)
              : props.estate?.completionSchMonth
                ? `${formatMonth(props.estate?.completionSchMonth)} 予定`
                : "−"}
          </Box>

          <Box>現況</Box>
          <Box>{currentStatus ?? "−"}</Box>

          <Box>明渡</Box>
          <Box>{clearingType ?? "−"}</Box>
        </Box>

        <ContentTail
          estate={props.estate}
          eSchools={props.eSchools}
          jSchools={props.jSchools}
          useDistricts={props.useDistricts}
        />

        <Box className={`${styles.memo} ${styles.condominium}`}>
          <Box>メモ</Box>
          <Box></Box>
        </Box>
      </ContentWrapper>
    );
  }
);
